import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation Login($username: String!, $password: String!) {
    loginWeb(loginInput: { username: $username, password: $password }) {
      accessToken
      user {
        id
        username
        email
        phone
        role {
          id
          name
        }
      }
    }
  }
`;

export const SIGNUP = gql`
mutation CreatePublicUser(
  $username: String!
  $password: String!
  $affiliateId: Float
  $phone: String
  $email: String
  $promoCode: String
) {
  createPublicUser(
    createPublicUserInput: {
      username: $username
      password: $password
      affiliateId: $affiliateId
      phone: $phone
      email: $email
      promoCode: $promoCode
    }
  ) {
    id
    username
    environment {
      id
      name
      host
    }
  }
}
`;
export const RESET_PASSWORD = gql`
mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(
        input: $input
    )
}
`;


export const CREATE_OTP = gql`
mutation CreateOtp($input: CreateOtpInput!) {
    createOtp(
        input: $input
    ){
        success
        message
        id
    }
}
`;

export const VERIFY_OTP = gql`
mutation VerifyOtp($input: VerifyOtpInput!) {
    verifyOtp(
        input: $input
    ){
        success
        message
        accessToken
    }
}
`;



export const GET_USER = gql`
  query GetUser($id: Int!) {
    user(id: $id) {
      id
      username
      email
      phone
      credit
      isActive
      parentId
      totalActiveBonus
      wagerBonus
      comment
      lastLogin
      loginIp
      avatarUrl
      language
      timezone
      createdAt
      updatedAt
      Balance {
        id
        amount
        onHold
      }
    }
  }
`;